export default function ShotMarker(props) {
  let { id, width, color } = props;
  return (
    <marker
      id={id}
      markerWidth={width}
      markerHeight={width * 3}
      refX={width / 2}
      refY={width / 2}
      orient="auto"
    >
      <g>
        <circle
          strokeDasharray={"100%"}
          //strokeDashArray is necessary because of a bug in Safari
          strokeWidth={1}
          stroke={color}
          fill={"none"}
          shapeRendering="geometricPrecision"
          r={0.35 * width}
          cx={0.5 * width}
          cy={0.5 * width}
        />

        <path
          strokeDasharray={"100%"}
          strokeWidth={1}
          stroke={color}
          d={`M ${width} ${width / 2} L ${0.65 * width} ${width / 2} `}
        />

        <path
          strokeDasharray={"100%"}
          strokeWidth={1}
          stroke={color}
          d={`M ${0} ${width / 2} L ${0.35 * width} ${width / 2} `}
        />

        <path
          strokeDasharray={"100%"}
          strokeWidth={1}
          stroke={color}
          d={`M ${width / 2}  ${0}  L  ${width / 2} ${0.35 * width} `}
        />

        <path
          strokeDasharray={"100%"}
          strokeWidth={1}
          stroke={color}
          d={`M ${width / 2}  ${width}  L  ${width / 2} ${0.65 * width} `}
        />
      </g>
    </marker>
  );
}
